<div class="modal-header">
  <h4 class="modal-title {{ titleClass }}" id="modal-basic-title">
    {{ title }}
  </h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="cancel.emit(0)"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div [innerHTML]="dangerousHTML" *ngIf="dangerousHTML"></div>
  <div *ngIf="!dangerousHTML">{{ description }}</div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn my-2"
    [ngClass]="confirmBtnClass || 'btn-success'"
    (click)="confirm.emit()"
  >
    {{ confirmBtnText }}
  </button>
  <button
    type="button"
    class="btn my-2"
    [ngClass]="cancelBtnClass || 'btn-light'"
    (click)="cancel.emit(1)"
  >
    {{ cancelBtnText }}
  </button>
</div>
